import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const resultPageWidgets = makeDynamicConfigWidgets([
  {
    name: 'welcome',
    cols: 6,
  },
  {
    name: 'evaluation',
    cols: 6,
  },
  {
    name: 'evaluationPropertyInformation',
    cols: 12,
    rows: 1,
  },
  {
    name: 'offer',
    cols: 8,
  },
  {
    name: 'blog',
    cols: 4,
  },
]);
